import { Record, String } from "runtypes";

export const VersionResponse = Record({
  version: String,
});
